import React from "react";
import "./Aboutfryright.css";

const Aboutfryright = () => {
  
  return (
    <div className="about-fry-right">
      <div className="aboutBlock1">
        <div className="contentWraper">
          <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/round6.webp" alt="#" className="abimage" />
          <div className="textwraper">
            <h2>
              {" "}
              <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/headerBackground.webp" alt="#" style={{ float: "right",marginTop:"10px" }} /> What is
              Fry Right System?{" "}
            </h2>
            <p className="textareatext">
              Scientifically developed and tested in dozens of kitchens, this
              proven process is the frying program your restaurant needs.
              <span>
                With The Fry Right System, you can provide a superior fried food
                experience that will keep your customers returning for more.
                <img
                  src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/food3.webp"
                  alt="#"
                  style={{ float: "right" }}
                  className="textdecimg"
                />
              </span>
              Maintain a consistently delicious experience from the beginning to
              end of your Quality Cycle<sup className=" TM">TM &nbsp;</sup>.
              Set a higher level of expectation with your fried food, and meet
              that expectation every single day for your customers!
            </p>
          </div>
        </div>
      </div>
      <div className="aboutBlock2">
        <div className="contentWraper">
          <div className="textwraper">
            <h2>How does the frying system work?</h2>
            <p>
              Using a blend of science and years of hands-on commercial kitchen
              experience, the Fry Right team has developed the first frying
              system of its kind. By simplifying a few scientific processes,
              your employees will be empowered to fry better, clean more
              effectively, and reduce oil waste. The best part - your food will
              taste better, be safe and thus healthier for your customers all
              cycle long! These superior benefits are the result of implementing
              our Quality Cycle<sup className=" TM">TM &nbsp;</sup>.
            </p>
          </div>
          <div className="abimage">
            <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/fries.webp" alt="#" />
          </div>
        </div>
      </div>

      <div className="aboutBlock3">
        <div className="contentWraper">
          <img className="fryricelogo" src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/fryRightlogo.webp" alt="#" />
          <div className="abimage-con">
            <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/round7.webp" alt="#" className="abimage" />
          </div>
          <div className="textwraper textlist1">
            <div className="header-container">
              {" "}
              <h2>
                The Fry Right Quality Cycle<sup className=" TM">TM</sup>{" "}
              </h2>{" "}
              <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/thumsup.webp" alt="#" />
            </div>

            <ul>
              <li>
                <p>
                  From implementation to support, The Fry Right System’s Quality
                  Cycle<sup className=" TM">TM &nbsp;</sup> provides onsite
                  training and tracking resources{" "}
                  <strong>
                    {" "}
                    that empower management and fry cooks with the ability to
                    achieve extremely long oil cycles, while reducing oil{" "}
                  </strong>
                  waste and providing consistent high quality fried food from
                  the first bite to the last bite of their oil cycle.
                </p>
              </li>
              <li>
                <p>
                  The Fry Right System’s Quality Cycle
                  <sup className=" TM">TM &nbsp;</sup> provides a way for
                  employees to view the frying section of their commercial
                  kitchen in a whole new light. The fryer goes from Gross to
                  Great. Imagine preferring to clean a fryer over the grill. 
                  Happens all the time where The Fry Right System’s Quality
                  Cycle
                  <sup className=" TM">TM &nbsp;</sup> is operating.
                </p>
              </li>
              <li>
                <p>
                  No longer will your management and crews not know what is
                  going on with their frying program. The Fry Right System will
                  teach them how to{" "}
                  <strong> control the chemistry of frying </strong> so they can
                  replicate the results of quality and longevity, cycle after
                  cycle.
                </p>
              </li>
              <li>
                <p style={{ marginTop: "0px" }}>
                  <strong>
                    Data input and review provides owners real time, empirical
                    information{" "}
                  </strong>
                  that helps them analyze how this profit center is either
                  costing them or profiting them. The Fry Right System always
                  aims to increase profits from this cooking tool.
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div className="contentWraper2 ">
          <div className="textwraper">
            <ul>
              <li>
                <p>
                  {" "}
                  This one of-a-kind system provides hope against one of the
                  most foul and hard jobs on the planet. The dreaded Boil-Out!
                  Cleaning dirty, oily, foul, nasty fryers can be a really
                  consistent, disgusting experience for employees!
                </p>
              </li>
              <li>
                <p style={{ marginTop: "0px" }}>
                  Our testimonials confirm that The Fry Right System’s Quality
                  Cycle<sup className=" TM">TM &nbsp;</sup> helps crews achieve
                  incredible and unbelievable results with a more positive
                  perspective. Give it a try, you will never look at frying the
                  same.{" "}
                </p>
              </li>
              <li>
                <p>
                  The Fry Right System measures the <span> “Guess Work”</span>{" "}
                  out of frying, and provides the benefits of a Quality Cycle
                  <sup className=" TM">TM &nbsp;</sup>
                  to your customers!
                </p>
              </li>
            </ul>
          </div>
          <div className="img-con">
            <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/food4.webp" alt="#" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aboutfryright;
